export default __webpack_public_path__ + "static/media/aircare-banner-3.4f503eb6.jpg";